module.exports = __webpack_public_path__ + "img/azxy5_icon.c2b96f7e.png";